import $ from 'jquery'
import ManageBanque from '@/components/parametres/parametre/param-banque/manage-banque'
import store_compte from '@/store/mods/caisse/compte.js'

export default {
    name: 'param-banque',
    components: {
        ManageBanque
    },
    props: [],
    data() {
        return {
            fields: [
                { key: 'no', label: 'N°' },  
                { key: 'libelle', label: 'Libelle' },
                { key: 'compte', label: 'N° de Compte' },
                { key: 'action', label: 'Action.s' }
            ],
           
            filter: "",
            perPage: -1,
            currentPage: 1,
            total_pages: 0,

            is_loading: false,
            is_empty: false,
            is_error: false,
            banques: [],
            search_filter: {},
            toggler: 0,
            selected_banque: {},
            is_edit: 0
        }
    },

    computed: {

    },

    mounted() {
        this.fetchBanques()
    },

    methods: {
        manageBanque() {
            this.is_edit = 0
            this.toggler = (this.toggler == 0)?1:0
            $('.mng-banque').modal('show')
        },

        setToEdit(data) {
            this.is_edit = 1
            this.toggler = (this.toggler == 0)?1:0
            $('.mng-banque').modal('show')

            this.selected_banque = data
        },

        fetchBanques() {
            this.is_loading = true

            store_compte.getCompteBanque().then((response) => {
                this.banques = response.data
                this.total_pages = response.last_page

                if(this.banques.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })

            this.is_empty = true
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.search_filter.page = this.currentPage
                this.fetchBanques(this.search_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.search_filter.page = this.currentPage
                this.fetchBanques(this.search_filter)
            }
        },

        gotoPage(page) {
            console.log("pg; ",page);
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.search_filter.page = this.currentPage
                this.fetchBanques(this.search_filter)
            }
        },
    }
}